import React from 'react'

import { strings } from './machine-relations-content'
import { SoracomSIM } from '../../../core/soracom-sims'
import styles from '../../styles/modules/machine-relations/machine-relations-query.module.scss'

interface Props {
  options: SoracomSIM[]
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
  value: number
}

const QuerySim: React.FC<Props> = props => (
  <div className={styles.container}>
    <span className={styles.title}>{strings.querySimTitle}</span>
    <div className={styles.wrapper}>
      <select
        className={styles.input}
        value={props.value}
        onChange={event => props.onChange(event)}
      >
        <option value={'@all'}>{strings.queryPlaceHolder}</option>
        {props.options.map(item => (
          <option value={item.id} key={item.id}>
            {`ID: ${item.id} ${item.serial}`}
          </option>
        ))}
      </select>
    </div>
  </div>
)

export default QuerySim
